// extracted by mini-css-extract-plugin
module.exports = {"termlink":"style_termlink__xHP8T"};